/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { EXCEPTION_TYPE } from '@interface/common'
import { ServerChecklistBanner } from '@views/ServerCheck/ServerCheckListBanner'
// image
import Whistle from '@assets/images/bg/whistle.png'
import NaverCafe from '@assets/images/icon/etc_icon/naver_cafe_mono.png'
import { LogoIco } from '@shared/Icon/LogoIcon'
// css
import styled from '@themes/theme'
import { Button } from '@styles/button.style'
import { AdvButton } from '@components/Button'
import googlePlayBtnImg from '@assets/images/bg/champ-poker/google-play-btn.png'
import appStoreBtnImg from '@assets/images/bg/champ-poker/app-store-btn.png'

const NoticeWrap = styled.div`
  display: block;
  padding: clamp(10px, 6vh, 40px) 62px 0;
  width: 100%;
  margin: 0 auto;

  .notice-img {
    display: block;
    width: 100%;
    height: 22vh;
    max-height: 143px;
    min-height: 98px;
    object-fit: contain;
    margin: 0 auto;
  }
  .notice-txt {
    width: calc(100% + 30px);
    transform: translateX(-15px);
    margin: clamp(10px, 1.88vh, 12px) auto clamp(12px, 2.5vh, 16px);
    text-align: center;
    font-size: ${props => props.theme.font.large};
    white-space: pre-wrap;
    line-height: 2.4rem;
  }
  .notice-btn {
    height: 38px;
    margin-bottom: clamp(12px, 2.5vh, 16px);
    &.naver-cafe {
      margin-bottom: clamp(10px, 1.88vh, 12px);
      background: #03C95A;
    }
    .naver-cafe-img, svg {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }
    .naver-cafe-img {
      left: 16px;
      width: 26px;
    }
    svg {
      left: 22px;
      width: auto;
      height: 16px;
      path {
        fill: ${props => props.theme.color.themeTxt};
      }
    }
  }
`
const NoticeBannerWrap = styled.div`
  padding: 0 28px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  ::before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #141414;
    margin-bottom: clamp(12px, 2.5vh, 16px);
  }
  .champ-down-btn-wrap {
    margin: clamp(10px, 1.88vh, 12px) 0 60px;
    display: flex;
    width: 100%;
    .champ-down-btn {
      width: 50%;
      > img {
        width: 100%;
        aspect-ratio: 155/45;
        object-fit: cover;
        object-position: left;
      }
      :first-of-type {
        > img {
          object-position: right;
        }
      }
    }
  }
`

const ServerCheck: React.FC = () => {
  const { gameStore, globalStore, componentStore } = useRootStore()
  const { maintenanceBanner } = componentStore
  const [element, setElement] = useState(null)
  const onClickCafeLinkAnchor = event => {
    const android = window.android
    if (android) {
      android.jnRequestOpenBrowser('https://cafe.naver.com/adventureronline')
    } else {
      globalStore.toMoveWebHomePage('https://cafe.naver.com/adventureronline', 'popup')
    }
  }
  const onClickHomePageLinkAnchor = event => {
    const android = window.android
    if (android) {
      android.jnRequestOpenBrowser(`${process.env.HOMEPAGE_MO}`)
    } else {
      globalStore.toMoveWebHomePage(`${isMobile ? process.env.HOMEPAGE_MO : process.env.HOMEPAGE_PC}`, 'popup')
    }
  }

  const onClickGooglePlayBtn = () => {
    componentStore.deepLinkingChampPokerByAndroid()
  }

  const onClickAppStoreBtn = () => {
    componentStore.deepLinkingChampPokerByIOS()
  }

  useOnMount(async () => {
    componentStore.fetchMaintenanceBanner().catch(console.error)
    const res = await gameStore.fetchServerCheck()
    const { error, detail } = res

    if (error && error === EXCEPTION_TYPE.SERVER_STATUS) {
      setElement(
        <Fragment>
          <NoticeWrap className="notice-wrap">
            <img src={Whistle} alt="호루라기 이미지" className="notice-img" />
            <div className="notice-txt">{detail}</div>
            <Button className="notice-btn naver-cafe" onClick={onClickCafeLinkAnchor} style={{ width: '100%' }}>
              <img src={NaverCafe} alt="네이버 카페" className="naver-cafe-img" />
              승부사온라인 공식 카페
            </Button>
            <Button secondary className="notice-btn" onClick={onClickHomePageLinkAnchor} style={{ width: '100%' }}>
              <LogoIco />
              승부사온라인 홈페이지
            </Button>
          </NoticeWrap>
        </Fragment>
      )
    } else {
      setElement(
        <Fragment>
          <NoticeWrap className="notice-wrap">
            <img src={Whistle} alt="호루라기 이미지" className="notice-img" />
            <div className="notice-txt">{detail}
              {/*{detail}*/}
              승부사 정기점검 진행 중 입니다.<br/><br/>
              16:30 ~ 17:30 까지 진행 될 예정이오니<br/><br/>
              자세한 내용은 홈페이지 확인 부탁 드립니다.
            </div>
            <Button className="notice-btn naver-cafe" onClick={onClickCafeLinkAnchor} style={{ width: '100%' }}>

              <img src={NaverCafe} alt="네이버 카페" className="naver-cafe-img" />
              승부사온라인 공식 카페
            </Button>
            <Button secondary className="notice-btn" onClick={onClickHomePageLinkAnchor} style={{ width: '100%' }}>
              <LogoIco />
              승부사온라인 홈페이지
            </Button>
          </NoticeWrap>
        </Fragment>
      )
    }
  })

  return (
    <Fragment>
      { element }
      {!!maintenanceBanner && (
        <NoticeBannerWrap className="notice-banner-wrap">
          <ServerChecklistBanner/>
          <div className="champ-down-btn-wrap">
            <AdvButton
              TP
              img={googlePlayBtnImg}
              className="champ-down-btn"
              onClick={onClickGooglePlayBtn}
            />
            <AdvButton
              TP
              img={appStoreBtnImg}
              className="champ-down-btn"
              onClick={onClickAppStoreBtn}
            />
          </div>
        </NoticeBannerWrap>
      )}
    </Fragment>
  )
}
export default observer(ServerCheck)
